import { RouteItem } from '@eastcoal/router/types/route'

import { ORGANIZATION_PAGE_PATH } from './constants/path'
import {
  ORGANIZATION_DEPT_ACTION_UUID,
  ORGANIZATION_PAGE_UUID,
  ORGANIZATION_USER_ACTION_UUID
} from './constants/uuid'

export const organizationRoute: RouteItem = {
  title: '组织架构',
  path: ORGANIZATION_PAGE_PATH,
  uuid: ORGANIZATION_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理部门',
      uuid: ORGANIZATION_DEPT_ACTION_UUID
    },
    {
      title: '管理用户',
      uuid: ORGANIZATION_USER_ACTION_UUID
    }
  ]
}
